import { useEffect, useRef } from 'react';
import $ from 'jquery';
import { BsHeadphones, BsBarChartLine } from 'react-icons/bs';
import { FiBriefcase, FiRss, FiCheckSquare } from 'react-icons/fi';
import ProjectCard from './ProjectCard';

const projects = [
  {
    title: 'Internship — Code212 UCA',
    desc: "Worked on fixing and improving the admin panel of the Code212 platform — a national coding education programme — during a web development internship at Bibliothèque Universitaire UCA.",
    tags: ['React', 'Laravel', 'TypeScript'],
    color: '#4ade80',
    Icon: FiBriefcase,
    link: null,
    github: null,
  },
  {
    title: 'Résonance Headphone',
    desc: 'E-commerce interface for headphones and responsive design.',
    tags: ['HTML5', 'CSS3', 'JavaScript'],
    color: '#00b4d8',
    Icon: BsHeadphones,
    link: 'https://zidane-nait-cheikh.github.io/Resonance-Final-Product/',
    github: 'https://github.com/Zidane-Nait-cheikh/Resonance-Final-Product',
  },
  {
    title: 'News App',
    desc: 'A clean, responsive news aggregator that fetches and displays articles by category, built with vanilla HTML, CSS, and JavaScript.',
    tags: ['JavaScript', 'HTML', 'CSS'],
    color: '#f4a261',
    Icon: FiRss,
    link: 'https://zidane-nait-cheikh.github.io/News-app/',
    github: 'https://github.com/Zidane-Nait-cheikh/News-app',
  },
  {
    title: 'Task Manager',
    desc: 'A productivity app to create, organise, and track tasks with priority levels and status updates, built with vanilla JavaScript.',
    tags: ['JavaScript', 'HTML', 'CSS'],
    color: '#e63946',
    Icon: FiCheckSquare,
    link: 'https://zidane-nait-cheikh.github.io/Task-pro/',
    github: 'https://github.com/Zidane-Nait-cheikh/Task-pro',
  },
  {
    title: 'Web Analyser',
    desc: "Outil d'analyse de sites web : performance, SEO, accessibilité, sécurité, liens. Disponible en interface web (UI) et en ligne de commande (CLI).",
    tags: ['Python', 'HTML', 'CSS'],
    color: '#9d4edd',
    Icon: BsBarChartLine,
    link: 'https://web-production-72153.up.railway.app',
    github: 'https://github.com/Zidane-Nait-cheikh/web-analyzer',
  },
];

export default function Projects() {
  const gridRef = useRef(null);

  useEffect(() => {
    // Subtle hover tilt — desktop only
    const mq = window.matchMedia('(hover:hover) and (pointer:fine)');
    if (mq.matches) {
      $(gridRef.current).find('.project-card').each(function () {
        $(this)
          .on('mousemove', function (e) {
            const r  = this.getBoundingClientRect();
            const rx = -((e.clientY - r.top)  / r.height - 0.5) * 10;
            const ry =  ((e.clientX - r.left) / r.width  - 0.5) * 10;
            $(this).css({ transform: `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`, transition: 'transform 0.1s linear' });
            const px = ((e.clientX - r.left) / r.width)  * 100;
            const py = ((e.clientY - r.top)  / r.height) * 100;
            $(this).find('.card-shine').css('background', `radial-gradient(circle at ${px}% ${py}%, rgba(255,255,255,0.07) 0%, transparent 55%)`);
          })
          .on('mouseleave', function () {
            $(this).css({ transform: 'perspective(900px) rotateX(0) rotateY(0)', transition: 'transform 0.5s ease' });
            $(this).find('.card-shine').css('background', 'none');
          });
      });
    }

    // Stagger scroll reveal
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        $(gridRef.current).find('.project-card').each(function (i) {
          const $c = $(this);
          setTimeout(() => $c.addClass('visible'), i * 120);
        });
        observer.disconnect();
      });
    }, { threshold: 0.1 });

    if (gridRef.current) observer.observe(gridRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="projects" className="projects-section reveal">
      <h2 className="section-title">My <span>Projects</span></h2>
      <p className="section-sub">Click any card to open the project · hover for 3D effect</p>
      <div ref={gridRef} className="projects-grid">
        {projects.map((p, i) => (
          <ProjectCard key={i} {...p} />
        ))}
      </div>
    </section>
  );
}
